import { Injectable } from '@angular/core'
import { environment } from '@employer/environments/environment'
import { isNotNil } from '@engineering11/utility'
import { RestApiClient } from '@engineering11/web-api-rest'
import { Store } from '@ngrx/store'
import { filter, map } from 'rxjs/operators'
import { getBaseSuffix } from 'shared-lib'
import { selectors } from '../store/selectors'

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private restApiClient: RestApiClient

  constructor(private store: Store) {
    this.restApiClient = new RestApiClient({
      baseUrl: environment.services.auth,
      token: store.select(selectors.getCurrentToken).pipe(filter(isNotNil)),
      baseSuffix: getBaseSuffix(environment, 'auth'),
    })
  }

  public customLoginToken() {
    return this.restApiClient.get<{ token: string; tenantId: string; tenantUrl?: string }>('/custom-token').pipe(map(item => item.data))
  }
}
